import React, { useCallback } from "react";
import PublicIcon from "@mui/icons-material/Public";
import FormValidation from "../../components/FormValidation/FormValidation";
import formFields from "../../config/formFields.json";

const AddTag = ({ open, onClose, initialData = null, onSubmit, tags = [] }) => {
  const isEdit = !!initialData;

  const initialValues = {
    tag_name: initialData?.tag_name || "",
    tag_description: initialData?.tag_description || "",
    tag_type: initialData?.tag_type || "",
  };
  const getOptionsForField = useCallback(
    (source) => {
      switch (source) {
        case "tag_type":
          return (
            tags?.map((tag) => ({
              value: tag.tag_type.toString(),
              label: tag.tag_type,
            })) || []
          );
        default:
          return [];
      }
    },
    [
      tags
    ]
  );

  return (
    <FormValidation
      open={open}
      onClose={onClose}
      initialData={initialValues}
      onSubmit={onSubmit}
      formFields={formFields?.tag.basic.fields}
      getOptionsForField={getOptionsForField}
      title="Tag"
      icon={PublicIcon}
      isEdit={isEdit}
      modelWidth="40vw"
    />
  );
};

export default AddTag;
